<template>
  <div class="dialogSystemMsg" @click="closeDialog">
    <el-dialog title="系统消息" :visible="$store.state.Dialog.dialogName === dialogName">
      <template v-if="messageList.length > 0 && messageList != undefined">
        <el-table
          :data="messageList"
          border
          stripe
          style="width: 100%" :show-header="showHeader">
          <el-table-column
            width="140">
            <template  scope="scope">
              <div slot="reference" class="name-wrapper">
                <span>{{ scope.row.createAt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="140"
            align='right'>
            <template  scope="scope">
              <div slot="reference" class="name-wrapper">
                <span>{{ scope.row.title }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="180">
            <template  scope="scope">
              <div slot="reference" class="name-wrapper">
                <span>{{ scope.row.content }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-else>
        <tr>
          <td>暂无系统消息</td>
        </tr>
      </template>
    </el-dialog>
  </div>
</template>

<script>
  import bus from '../../assets/js/bus'
  export default ({
    props:['messageList','dialogName'],
    data(){
      return({
        showHeader:false,
      });
    },
    mounted(){
      this.$nextTick(function(){
        var that = this;
      })
    },
    computed: {

    },
    methods:{
      closeDialog(event){
        this.$store.commit('closeDialog',{
          className:event.target.className
        })
      }
    }
  })
</script>

<style lang="scss">
  .dialogSystemMsg{
    .el-dialog{
      width: 500px;
    }
  }
</style>



// WEBPACK FOOTER //
// dialogSystemMsg.vue?015540d2